import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { EncounterPreventionService, ExclusionGroupWithOverrides } from 'app/services/encounter-prevention.service';
import { FeatureFlagService, FLAGS } from 'app/services/feature-flag.service';
import { take } from 'rxjs/operators';
import { EncountersState } from '../encounter-prevention-dialog.component';

@Component({
	selector: 'app-encounter-group-description',
	templateUrl: './encounter-group-description.component.html',
	styleUrls: ['./encounter-group-description.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EncounterGroupDescriptionComponent implements OnInit {
	@Input() state!: EncountersState;
	@Input() group!: ExclusionGroupWithOverrides;
	@Input() collapseGroups = false;

	displayGroup!: ExclusionGroupWithOverrides;
	loading = false;

	activityEPFF = this.featureFlagService.isFeatureEnabledV2(FLAGS.ActivityEncounterPreventionFF);

	constructor(private ePService: EncounterPreventionService, private cdRef: ChangeDetectorRef, private featureFlagService: FeatureFlagService) {}

	ngOnInit(): void {
		if (this.group.prevented_encounters.length === 0 && this.group.id) {
			this.loading = true;
			this.ePService
				.getExclusionGroup(this.group.id)
				.pipe(take(1))
				.subscribe((group) => {
					this.displayGroup = group;
					this.reverseOrder();
					this.loading = false;
					this.cdRef.markForCheck();
				});
		} else {
			this.displayGroup = this.group;
			this.reverseOrder();
		}
	}

	reverseOrder(): void {
		this.displayGroup.prevented_encounters = (this.displayGroup.prevented_encounters ?? []).slice().reverse();
	}
}
